/**
 * 整看 整听 整提示（预习，整段故事）
 */
export const TYPES = {
  AUDIO: 'AUDIO',
  VIDEO: 'VIDEO',
  TIPS: 'TIPS',
}

/**
 * 整看 整听 整提示（预习，整段故事）
 */
export const TYPES_LABEL = {
  AUDIO: '小说录音',
  VIDEO: '大复习指读',
  TIPS: '整看提示',
}

export const PREVIEW_ELEMENT = {
  /**
   * @description 整听
   */
  AUDIO: 1,
  /**
   * @description 整提示
   */
  TIPS: 2,
  /**
   * @description 整看
   */
  VIDEO: 3,
}
